export enum ReactElementStatus {
    /** Начальное состояние элемента */
    INITIAL = 'initial',
    /** Элемент находится в процессе активации/деактивации */
    PENDING = 'pending',
    /** Элемент активирован */
    ACTIVATED = 'activated',
    /** Элемент деактивировался */
    DEACTIVATED = 'deactivated',
    /** Во время активации/деактивации произошла ошибка */
    ERROR = 'error',
}

type HandlerFunction = (...args: unknown[]) => void;
type ErrorFunction = (error: Error) => void;
export interface ReactLoaderHolderHandlerObject {
    onAction: HandlerFunction;
    onError: ErrorFunction;
}

export enum ReactLoaderHolderHandlerType {
    ACTIVATE = 'activate',
    DEACTIVATE = 'deactivate',
}

export interface IReactElementLoaderHolder {
    $reactLoader?: ReactLoaderHolder<ReactElementLoaderHolder>;
}
export type ReactElementLoaderHolder = IReactElementLoaderHolder & HTMLElement;

/**
 * Класс для управления состоянием реакт-приложения
 */
export class ReactLoaderHolder<E extends ReactElementLoaderHolder = ReactElementLoaderHolder> {
    /** Элемент (реакт-приложение) которым управляем */
    private element: E;
    /** Статус Реакт-приложения */
    private status: ReactElementStatus;
    /** Обработчики, которые нужно вызвать после активации элемента */
    private activateHandlers: ReactLoaderHolderHandlerObject[];
    /** Обработчики, которые нужно вызвать после деактивации элемента */
    private deactivateHandlers: ReactLoaderHolderHandlerObject[];

    constructor(element: E) {
        this.element = element;
        this.element.$reactLoader = this;
        this.status = ReactElementStatus.INITIAL;
        this.activateHandlers = [];
        this.deactivateHandlers = [];
    }

    getStatus(): ReactElementStatus {
        return this.status;
    }

    setStatus(status: ReactElementStatus): void {
        this.status = status;
    }

    addHandler(handler: ReactLoaderHolderHandlerObject, type: ReactLoaderHolderHandlerType): void {
        const handlerArr = this.getHandlerArrayByType(type);
        handlerArr.push(handler);
    }

    fireHandlers(type: ReactLoaderHolderHandlerType, ...args: any[]): void {
        const handlers = this.getHandlerArrayByType(type);

        handlers.forEach((item) => {
            try {
                item.onAction(...args);
            } catch (error) {
                item.onError(error as Error);
            }
        });
    }

    private getHandlerArrayByType(type: ReactLoaderHolderHandlerType): ReactLoaderHolderHandlerObject[] {
        switch (type) {
            case ReactLoaderHolderHandlerType.ACTIVATE:
                return this.activateHandlers;
            case ReactLoaderHolderHandlerType.DEACTIVATE:
                return this.deactivateHandlers;
            default:
                return [];
        }
    }
}

export function getReactLoaderHolder(element: ReactElementLoaderHolder): ReactLoaderHolder {
    if (element.$reactLoader) {
        return element.$reactLoader;
    }

    return new ReactLoaderHolder<ReactElementLoaderHolder>(element);
}
